import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "company-detail-view" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = {
  key: 1,
  class: "empty-container"
}
const _hoisted_4 = {
  key: 2,
  class: "company-detail-container"
}
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "company-flags" }
const _hoisted_8 = { class: "card-actions" }
const _hoisted_9 = { class: "info-grid" }
const _hoisted_10 = { class: "info-item" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "info-item" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "info-item" }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "info-item status-item" }
const _hoisted_17 = { class: "info-item" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "info-item full-width" }
const _hoisted_20 = {
  key: 0,
  class: "info-item full-width"
}
const _hoisted_21 = { class: "note-content" }
const _hoisted_22 = { class: "info-item" }
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "info-item" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "card-header" }
const _hoisted_27 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_28 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_29 = {
  key: 2,
  class: "positions-list"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "position-info" }
const _hoisted_32 = { class: "position-title" }
const _hoisted_33 = { class: "position-tags" }
const _hoisted_34 = { class: "position-meta" }
const _hoisted_35 = {
  key: 0,
  class: "salary-range"
}
const _hoisted_36 = {
  key: 1,
  class: "deadline"
}
const _hoisted_37 = { class: "position-actions" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "position-item-arrow" }
const _hoisted_41 = { class: "card-header" }
const _hoisted_42 = {
  key: 0,
  class: "card-subtitle"
}
const _hoisted_43 = {
  key: 1,
  class: "loading-container"
}
const _hoisted_44 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_45 = {
  key: 3,
  class: "empty-state"
}
const _hoisted_46 = {
  key: 4,
  class: "interviews-list"
}
const _hoisted_47 = { class: "latest-position-info" }
const _hoisted_48 = { class: "latest-position-title" }
const _hoisted_49 = { class: "interview-status" }
const _hoisted_50 = { class: "interview-content" }
const _hoisted_51 = { class: "interview-header" }
const _hoisted_52 = { class: "interview-stage" }
const _hoisted_53 = { class: "interview-time" }
const _hoisted_54 = { class: "interview-details" }
const _hoisted_55 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_56 = {
  key: 1,
  class: "detail-item"
}
const _hoisted_57 = {
  key: 0,
  class: "interview-notes"
}
const _hoisted_58 = {
  key: 0,
  class: "more-interviews"
}
const _hoisted_59 = { class: "dialog-footer" }

import { ref, onMounted, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { Star, Top, Edit, Delete, Calendar, ArrowRight, Collection, Location, User } from '@element-plus/icons-vue';
import CompanyForm from '@/components/company/CompanyForm.vue';
import CompanyStatusTag from '@/components/company/CompanyStatusTag.vue';
import { useCompanyStore } from '@/store/companyStore';
import type { Company } from '@/types/company';
import { ElMessageBox, ElMessage } from 'element-plus';
import { usePositionStore } from '@/store/positionStore';
import type { Position } from '@/types/position';
import PositionItem from '@/components/position/PositionItem.vue';
import PositionForm from '@/components/position/PositionForm.vue';
import { WORK_TYPE_OPTIONS } from '@/types/position';
import ResourceList from '@/components/resource/ResourceList.vue';
import interviewService from '@/services/interviewService';
import type { Interview } from '@/types/interview';
import { INTERVIEW_STAGES, INTERVIEW_STATUS } from '@/types/interview';


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyDetailView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const companyStore = useCompanyStore();
const positionStore = usePositionStore();

// 表单引用
const editFormRef = ref<any>();

// 对话框
const editDialogVisible = ref(false);
const positionDialogVisible = ref(false);
const newPosition = ref<Partial<Position>>({});
const latestPosition = ref<Position | null>(null);
const recentInterviews = ref<Interview[]>([]);
const loadingInterviews = ref(false);

// 页面初始化时加载数据
onMounted(async () => {
  const companyId = Number(route.params.id);
  if (!isNaN(companyId)) {
    await loadCompanyDetail(companyId);
    if (companyStore.currentCompany.id) {
      await loadPositions();
      
      // 获取最近更新的职位及其面试记录
      await loadRecentInterviews();
      
      // 处理锚点跳转
      if (route.hash === '#positions') {
        await nextTick();
        const element = document.getElementById('positions');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else if (route.hash === '#resources') {
        await nextTick();
        const element = document.getElementById('resources');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else if (route.hash === '#interviews') {
        await nextTick();
        const element = document.getElementById('interviews');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  }
});

// 加载公司详情
const loadCompanyDetail = async (id: number) => {
  await companyStore.getCompany(id);
};

// 返回上一页
const goBack = () => {
  router.push('/resources');
};

// 打开编辑对话框
const openEditDialog = () => {
  editDialogVisible.value = true;
};

// 提交编辑表单
const submitEditForm = () => {
  if (editFormRef.value) {
    editFormRef.value.submitForm();
  }
};

// 处理更新公司
const handleUpdateCompany = async (company: Company) => {
  try {
    // 只发送后端需要的字段
    const updateData = {
      id: company.id,
      name: company.name,
      companyType: company.companyType,
      recruitmentUrl: company.recruitmentUrl,
      status: company.status,
      notes: company.notes,
      industry: company.industry,
      location: company.location,
      contactPerson: company.contactPerson,
      isStarred: company.isStarred,
      isPinned: company.isPinned
    };
    
    await companyStore.updateCompany(updateData);
    editDialogVisible.value = false;
    
    // 重新加载公司详情以获取最新数据
    if (company.id) {
      await loadCompanyDetail(company.id);
    }
  } catch (error) {
    console.error('更新公司失败', error);
  }
};

// 格式化URL
const formatUrl = (url: string) => {
  if (!url) return '';
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return 'https://' + url;
  }
  return url;
};

// 添加删除确认和处理功能
// 确认删除公司
const confirmDelete = () => {
  if (!companyStore.currentCompany?.id) return;
  
  ElMessageBox.confirm(
    `确定要删除公司 "${companyStore.currentCompany.name}" 吗？此操作不可恢复。`,
    '警告',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(() => {
    handleDeleteCompany();
  }).catch(() => {
    // 用户取消删除操作
  });
};

// 处理删除公司
const handleDeleteCompany = async () => {
  if (!companyStore.currentCompany?.id) return;
  
  try {
    const result = await companyStore.deleteCompany(companyStore.currentCompany.id);
    if (result) {
      // 删除成功后返回列表页
      router.push('/resources');
    }
  } catch (error) {
    console.error('删除公司失败', error);
    
    // 检查是否是外键约束错误
    if (error.response?.data?.message?.includes('foreign key constraint fails') ||
        error.message?.includes('foreign key constraint fails')) {
      ElMessageBox.alert(
        '该公司下存在关联的职位信息，无法直接删除。请先删除所有关联的职位后再尝试删除公司。',
        '删除失败',
        {
          confirmButtonText: '确定',
          type: 'error',
        }
      );
    } else {
      // 其他类型的错误
      ElMessageBox.alert(
        '删除公司时发生错误，请稍后重试。',
        '删除失败',
        {
          confirmButtonText: '确定',
          type: 'error',
        }
      );
    }
  }
};

const loadPositions = async () => {
  try {
    await positionStore.getPositionsByCompany(companyStore.currentCompany.id as number, 1);
  } catch (error) {
    console.error('加载职位列表失败', error);
  }
};

const showAddPositionDialog = () => {
  newPosition.value = {
    companyId: companyStore.currentCompany.id,
    applicationStatus: 'not_started',
    interviewStatus: 'not_scheduled',
    workType: 'full_time',
    priority: 2,
    salaryCurrency: 'CNY'
  };
  positionDialogVisible.value = true;
};

const handlePositionClick = (position: Position) => {
  router.push(`/resources/positions/${position.id}`);
};

const handlePositionSubmit = async (position: Partial<Position>) => {
  try {
    await positionStore.createPosition(position);
    ElMessage.success('职位添加成功');
    positionDialogVisible.value = false;
    await loadPositions();
  } catch (error) {
    ElMessage.error('添加职位失败');
    console.error(error);
  }
};

const getWorkTypeLabel = (type: string) => {
  const option = WORK_TYPE_OPTIONS.find(opt => opt.value === type);
  return option ? option.label : type;
};

const formatDate = (dateString: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('zh-CN', { 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit' 
  });
};

const navigateToInterviews = (position: Position) => {
  // 阻止事件冒泡，避免触发整个行的点击事件
  event?.stopPropagation();
  if (position.id) {
    router.push(`/resources/positions/${position.id}#interviews`);
  }
};

const handleResourceRefresh = () => {
  // 实现资源列表刷新逻辑
  console.log('资源列表刷新');
};

// 查看职位相关资源
const handleViewResources = (position: Position) => {
  router.push(`/resources/positions/${position.id}`);
};

const handleEditPosition = (position: Position) => {
  // 实现编辑职位逻辑
  console.log('编辑职位', position);
};

const handleDeletePosition = (position: Position) => {
  // 实现删除职位逻辑
  console.log('删除职位', position);
};

// 加载最近更新的职位及其面试记录
const loadRecentInterviews = async () => {
  if (!positionStore.positions.length) return;
  
  loadingInterviews.value = true;
  console.log('开始获取面试记录，职位数量:', positionStore.positions.length);
  
  try {
    // 存储所有职位的最新面试记录
    const positionInterviews: { position: Position; interviews: Interview[] }[] = [];
    
    // 遍历所有职位，获取每个职位的面试记录
    for (const position of positionStore.positions) {
      if (position.id) {
        try {
          console.log(`获取职位 ${position.id} (${position.title || 'unnamed'}) 的面试记录`);
          const response = await interviewService.getInterviewsByPosition(position.id);
          console.log(`职位 ${position.id} 的响应:`, response);
          
          // 检查响应的具体结构
          let interviews: Interview[] = [];
          if (response && response.code === 200 && response.data) {
            console.log('响应数据类型:', typeof response.data);
            if (Array.isArray(response.data)) {
              interviews = response.data;
              console.log('数据是数组');
            } else if (response.data.content && Array.isArray(response.data.content)) {
              interviews = response.data.content;
              console.log('数据是分页对象');
            } else {
              console.warn('未知的响应数据结构:', response.data);
            }
          } else if (Array.isArray(response)) {
            interviews = response;
            console.log('直接返回的是数组');
          } else if (response && response.content && Array.isArray(response.content)) {
            interviews = response.content;
            console.log('直接返回的是分页对象');
          }
          
          console.log(`找到 ${interviews.length} 条面试记录`);
          
          if (interviews.length > 0) {
            // 按面试时间排序，最近的排在前面
            const sortedInterviews = [...interviews].sort((a, b) => {
              // 计算与当前时间的差值，用绝对值来处理过去和将来的面试
              const now = new Date().getTime();
              const diffA = Math.abs(new Date(a.dateTime).getTime() - now);
              const diffB = Math.abs(new Date(b.dateTime).getTime() - now);
              return diffA - diffB;
            });
            
            // 存储该职位及其面试记录
            positionInterviews.push({
              position,
              interviews: sortedInterviews
            });
          }
        } catch (error) {
          console.error(`获取职位 ${position.id} 的面试记录失败`, error);
        }
      }
    }
    
    console.log('收集到的职位面试记录:', positionInterviews.length);
    
    // 如果有面试记录，找出最近面试时间的职位
    if (positionInterviews.length > 0) {
      // 按最近面试时间排序所有职位
      positionInterviews.sort((a, b) => {
        // 计算每个职位最近的面试时间与当前时间的差值
        const now = new Date().getTime();
        const latestA = a.interviews[0]?.dateTime || '1970-01-01';
        const latestB = b.interviews[0]?.dateTime || '1970-01-01';
        const diffA = Math.abs(new Date(latestA).getTime() - now);
        const diffB = Math.abs(new Date(latestB).getTime() - now);
        return diffA - diffB;
      });
      
      // 取最新面试记录的职位
      const latest = positionInterviews[0];
      console.log('最新面试记录的职位:', latest.position.title, '面试数量:', latest.interviews.length);
      latestPosition.value = latest.position;
      recentInterviews.value = latest.interviews;
    } else {
      // 没有面试记录，则显示最新更新的职位
      console.log('没有找到面试记录，显示最新更新的职位');
      const sortedPositions = [...positionStore.positions].sort((a, b) => {
        return new Date(b.updateTime || 0).getTime() - new Date(a.updateTime || 0).getTime();
      });
      
      if (sortedPositions.length > 0) {
        latestPosition.value = sortedPositions[0];
        recentInterviews.value = [];
        console.log('选择了最新更新的职位:', latestPosition.value.title);
      }
    }
  } catch (error) {
    console.error('加载面试记录失败', error);
  } finally {
    loadingInterviews.value = false;
  }
};

// 获取面试阶段标签
const getInterviewStageLabel = (stage: string) => {
  return INTERVIEW_STAGES[stage as keyof typeof INTERVIEW_STAGES] || stage;
};

// 获取面试状态标签
const getInterviewStatusLabel = (status: string) => {
  return INTERVIEW_STATUS[status as keyof typeof INTERVIEW_STATUS] || status;
};

// 格式化面试时间
const formatInterviewTime = (dateTime: string) => {
  if (!dateTime) return '';
  const date = new Date(dateTime);
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_application_status_tag = _resolveComponent("application-status-tag")!
  const _component_interview_status_tag = _resolveComponent("interview-status-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_page_header, {
      onBack: goBack,
      title: "公司管理",
      content: _unref(companyStore).currentCompany?.name || '公司详情'
    }, null, 8, ["content"]),
    (_unref(companyStore).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_skeleton, {
            rows: 10,
            animated: ""
          })
        ]))
      : (!_unref(companyStore).currentCompany)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_empty, { description: "未找到公司信息" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: goBack
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("返回列表")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_card, { class: "detail-card" }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h2", null, _toDisplayString(_unref(companyStore).currentCompany.name), 1),
                    _createElementVNode("div", _hoisted_7, [
                      (_unref(companyStore).currentCompany.isStarred)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            type: "warning",
                            effect: "dark"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Star))
                                ]),
                                _: 1
                              }),
                              _cache[9] || (_cache[9] = _createTextVNode(" 已收藏 "))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(companyStore).currentCompany.isPinned)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            type: "warning",
                            effect: "dark"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Top))
                                ]),
                                _: 1
                              }),
                              _cache[10] || (_cache[10] = _createTextVNode(" 已置顶 "))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: openEditDialog
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Edit))
                          ]),
                          _: 1
                        }),
                        _cache[11] || (_cache[11] = _createTextVNode(" 编辑 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "danger",
                      onClick: confirmDelete
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Delete))
                          ]),
                          _: 1
                        }),
                        _cache[12] || (_cache[12] = _createTextVNode(" 删除 "))
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "label" }, "公司类型", -1)),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(companyStore).currentCompany.companyType), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "label" }, "行业", -1)),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(companyStore).currentCompany.industry || '未设置'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "所在地", -1)),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(companyStore).currentCompany.location || '未设置'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "状态", -1)),
                    _createVNode(CompanyStatusTag, {
                      status: _unref(companyStore).currentCompany.status
                    }, null, 8, ["status"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "联系人", -1)),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(companyStore).currentCompany.contactPerson || '未设置'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "招聘官网", -1)),
                    _createVNode(_component_el_link, {
                      href: formatUrl(_unref(companyStore).currentCompany.recruitmentUrl),
                      target: "_blank",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(companyStore).currentCompany.recruitmentUrl), 1)
                      ]),
                      _: 1
                    }, 8, ["href"])
                  ]),
                  (_unref(companyStore).currentCompany.notes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "备注", -1)),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(companyStore).currentCompany.notes), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "创建时间", -1)),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(companyStore).currentCompany.createTime || '未知'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "更新时间", -1)),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(companyStore).currentCompany.updateTime || '未知'), 1)
                  ])
                ])
              ]),
              _: 1
            }),
            (_unref(companyStore).currentCompany.id)
              ? (_openBlock(), _createBlock(_component_el_card, {
                  key: 0,
                  class: "position-card",
                  id: "positions"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[23] || (_cache[23] = _createElementVNode("h3", null, "关联职位", -1)),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "small",
                        onClick: showAddPositionDialog
                      }, {
                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                          _createTextVNode("添加职位")
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    (_unref(positionStore).loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createVNode(_component_el_skeleton, {
                            rows: 3,
                            animated: ""
                          })
                        ]))
                      : (_unref(positionStore).positions.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createVNode(_component_el_empty, { description: "暂无关联职位" })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(positionStore).positions, (position) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: position.id,
                                class: "position-list-item"
                              }, [
                                _createElementVNode("div", {
                                  class: "position-item-content",
                                  onClick: ($event: any) => (handlePositionClick(position))
                                }, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("h3", _hoisted_32, _toDisplayString(position.title), 1),
                                    _createElementVNode("div", _hoisted_33, [
                                      _createVNode(_component_application_status_tag, {
                                        status: position.applicationStatus,
                                        size: "small"
                                      }, null, 8, ["status"]),
                                      _createVNode(_component_interview_status_tag, {
                                        status: position.interviewStatus,
                                        size: "small"
                                      }, null, 8, ["status"]),
                                      _createVNode(_component_el_tag, {
                                        size: "small",
                                        effect: "plain"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(getWorkTypeLabel(position.workType)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_34, [
                                    (position.minSalary && position.maxSalary)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(position.minSalary) + "-" + _toDisplayString(position.maxSalary) + " " + _toDisplayString(position.salaryCurrency || 'CNY'), 1))
                                      : _createCommentVNode("", true),
                                    (position.deadline)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Calendar))
                                            ]),
                                            _: 1
                                          }),
                                          _createTextVNode(" 截止日期: " + _toDisplayString(formatDate(position.deadline)), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 8, _hoisted_30),
                                _createElementVNode("div", _hoisted_37, [
                                  _createVNode(_component_el_tooltip, {
                                    content: "查看资源",
                                    placement: "top"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: "action-icon view",
                                        onClick: ($event: any) => (handleViewResources(position))
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Collection))
                                          ]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_38)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_tooltip, {
                                    content: "查看面试记录",
                                    placement: "top"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: "action-icon interview",
                                        onClick: ($event: any) => (navigateToInterviews(position))
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Calendar))
                                          ]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_39)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("div", _hoisted_40, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ArrowRight))
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(ResourceList, {
              "company-id": _unref(companyStore).currentCompany.id,
              onRefresh: handleResourceRefresh,
              id: "resources"
            }, null, 8, ["company-id"]),
            (_unref(companyStore).currentCompany.id)
              ? (_openBlock(), _createBlock(_component_el_card, {
                  key: 1,
                  class: "interview-card",
                  id: "interviews"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_41, [
                      _cache[25] || (_cache[25] = _createElementVNode("h3", null, "面试记录", -1)),
                      (latestPosition.value)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            size: "small",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(`/resources/positions/${latestPosition.value.id}#interviews`)))
                          }, {
                            default: _withCtx(() => _cache[24] || (_cache[24] = [
                              _createTextVNode(" 查看更多 ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  default: _withCtx(() => [
                    (latestPosition.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, _cache[26] || (_cache[26] = [
                          _createElementVNode("span", null, "显示最近面试时间的岗位记录，按面试时间排序先后显示", -1)
                        ])))
                      : _createCommentVNode("", true),
                    (loadingInterviews.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createVNode(_component_el_skeleton, {
                            rows: 3,
                            animated: ""
                          })
                        ]))
                      : (!latestPosition.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createVNode(_component_el_empty, { description: "没有找到任何职位信息" })
                          ]))
                        : (recentInterviews.value.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _createVNode(_component_el_empty, { description: "暂无面试记录" }, {
                                description: _withCtx(() => [
                                  _createElementVNode("p", null, _toDisplayString(latestPosition.value.title || '当前职位') + "暂无面试记录", 1)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push(`/resources/positions/${latestPosition.value.id}#interviews`)))
                                  }, {
                                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                                      _createTextVNode(" 添加面试 ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("span", _hoisted_48, _toDisplayString(latestPosition.value?.title) + " 的最近面试", 1)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentInterviews.value.slice(0, 2), (interview) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: interview.id,
                                  class: "interview-item",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push(`/resources/positions/${latestPosition.value?.id}#interviews`)))
                                }, [
                                  _createElementVNode("div", _hoisted_49, [
                                    _createVNode(_component_el_tag, {
                                      type: interview.status === 'completed' ? 'success' : 
                         interview.status === 'cancelled' ? 'danger' : 
                         interview.status === 'rescheduled' ? 'warning' : 'info',
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(getInterviewStatusLabel(interview.status || 'pending')), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["type"])
                                  ]),
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                      _createElementVNode("span", _hoisted_52, _toDisplayString(getInterviewStageLabel(interview.stage)), 1),
                                      _createElementVNode("span", _hoisted_53, _toDisplayString(formatInterviewTime(interview.dateTime)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_54, [
                                      (interview.location)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(Location))
                                              ]),
                                              _: 1
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(interview.location), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (interview.interviewer)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(User))
                                              ]),
                                              _: 1
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(interview.interviewer), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (interview.notes)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                          _createElementVNode("p", null, _toDisplayString(interview.notes), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128)),
                              (recentInterviews.value.length > 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    _createVNode(_component_el_button, {
                                      type: "text",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push(`/resources/positions/${latestPosition.value?.id}#interviews`)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" 查看全部面试记录 (" + _toDisplayString(recentInterviews.value.length) + ") ", 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])),
    _createVNode(_component_el_dialog, {
      modelValue: editDialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editDialogVisible).value = $event)),
      title: "编辑公司",
      width: "600px",
      "close-on-click-modal": false,
      "destroy-on-close": true
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_59, [
          _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (editDialogVisible.value = false))
          }, {
            default: _withCtx(() => _cache[28] || (_cache[28] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitEditForm,
            loading: _unref(companyStore).loading
          }, {
            default: _withCtx(() => _cache[29] || (_cache[29] = [
              _createTextVNode(" 保存 ")
            ])),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(CompanyForm, {
          ref_key: "editFormRef",
          ref: editFormRef,
          "initial-data": _unref(companyStore).currentCompany,
          loading: _unref(companyStore).loading,
          onSubmit: handleUpdateCompany
        }, null, 8, ["initial-data", "loading"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: positionDialogVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((positionDialogVisible).value = $event)),
      title: "添加职位",
      width: "60%",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        (positionDialogVisible.value)
          ? (_openBlock(), _createBlock(PositionForm, {
              key: 0,
              position: newPosition.value,
              loading: _unref(positionStore).loading,
              onSubmit: handlePositionSubmit,
              onCancel: _cache[6] || (_cache[6] = ($event: any) => (positionDialogVisible.value = false))
            }, null, 8, ["position", "loading"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})